import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from '../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { Utility } from '../../common/utility';
import { ValidationService } from '../../shared/services/validation.service';
import { Patient } from '../../models/patient/patient.model'

@Component({
  selector: 'search-patient',
  templateUrl: 'search-patient.component.html'
})
export class SearchPatientComponent implements OnInit {
  public searchPatientForm: FormGroup;
  public filterData = {
    searchType: null,
    email: '',
  }
  public dataColumns = [
  'name',
  'date',
  'address',
  'phone',
  'email'
  ];

  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: 'total' // Footer total message
  };
  public customClasses = AppConstants.table.footerClasses;

  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    private router: Router) {}

  ngOnInit() {
    this.createForm();

    $(document).ready( function () {
      $('#searchTable').DataTable({
        searching: false, 
        paging: false,
        ordering: false,
        info: false
      });
    });
  }

  onChange() {
    //console.log(this.filterData.searchType);
  }

  createForm() {
    this.searchPatientForm = this.formBuilder.group({
      email: ['', [Validators.required, ValidationService.isValidEmail]],
    });
  }

  onSearch() {
    if (this.searchPatientForm.valid && this.searchPatientForm.dirty) {
      console.log("Success");
    }
  }

  onAddPatient() {
    this.router.navigate(['/add-patient']);
  }

  onCancel() {

  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/search-patient/search-patient.component.ts